import { SoapUtils } from '../../../../utils/SoapUtils';
import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export class ItemValue{
    public id? : number;
    public acl? : string;
    public formInfo?: number;
    public formItem?: number;
    public formItemName?: string;
    public value?: string;
    public context?: string;
    public typ?: string;

    constructor(id?: number, acl?: string, formInfo?: number, formItem?: number, formItemName?: string, value?: string, typ?: string, context?: string){
        this.id = id;
        this.acl = acl;
        this.formInfo = formInfo;
        this.formItem = formItem;
        this.formItemName = formItemName;
        this.value = value;
        this.context = context;
        this.typ = typ;
    }

    public toXml(): string {
        var xml: string = '';
        xml += SoapUtils.makeNode(this.id, 'id');
        xml += SoapUtils.makeNode(this.acl, 'acl');
        xml += SoapUtils.makeNode(this.formInfo, 'formInfo');
        xml += SoapUtils.makeNode(this.formItem, 'formItem');
        xml += SoapUtils.makeNode(this.formItemName, 'formItemName');
        // Stringify value so falsy values (e.g. false, 0) are sent in XML; omit only when undefined/null
        const valueForXml = this.value !== undefined && this.value !== null ? String(this.value) : undefined;
        xml += SoapUtils.makeNode(valueForXml, 'value');
        xml += SoapUtils.makeNode(this.context, 'context');
        xml += SoapUtils.makeNode(this.typ, 'typ');
        return `<ITEMVALUE>${xml}</ITEMVALUE>`;
    }
}

export interface IUpdateItemValueRequest extends IBaseRequest {
    ITEMVALUE? : ItemValue[];
}

export class UpdateItemValueRequest extends BaseRequest implements IUpdateItemValueRequest {

    public ITEMVALUE?: ItemValue[] = [];
    constructor(server: string, session: string, itemValue?: ItemValue[]) {
        super(server, session);
        this.ITEMVALUE = itemValue;
    }

  public toXml(): string {
    var parameters: string = super.toXml();
    if (this.ITEMVALUE) {
      this.ITEMVALUE.forEach((itemValue: ItemValue) => {
        parameters += itemValue.toXml();
      });
    }
    return super.wrapperXml('UpdateItemValue', parameters);
  }
}
